/* (ignored) */


//////////////////
// WEBPACK FOOTER
// ./lib/locales (ignored)
// module id = 1003
// module chunks = 0